import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer.js";
import JsonLd from "./JsonLd.js";
import GuideCoverHero from "./guide/GuideCoverHero.js";
import GuideTableOfContents from "./guide/GuideTableOfContents.js";
import { STRUCTURED_THINKING_GUIDE } from "../constants/structuredThinkingGuide.js";
import { STRUCTURED_THINKING_COVER } from "../constants/structuredThinkingGuideVisuals.js";
import { buildGuideJsonLd } from "../utils/guideJsonLd.js";
import "../mental-clarity-guide.css";

const DEFAULT_TITLE = "Ahavibes — Stop reacting. Start thinking clearly.";
const DEFAULT_DESCRIPTION =
  "A guided framework to examine interpretations, reduce mental noise, and make better decisions.";
const PAGE_TITLE = "Structured Thinking: A Practical Guide | Ahavibes";

const StructuredThinking = () => {
  const jsonLd = useMemo(() => buildGuideJsonLd(STRUCTURED_THINKING_GUIDE), []);

  useEffect(() => {
    document.title = PAGE_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    const createdMeta = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const previousDescription = meta.getAttribute("content");
    meta.setAttribute("content", STRUCTURED_THINKING_GUIDE.description);

    return () => {
      document.title = DEFAULT_TITLE;
      if (createdMeta) {
        meta.remove();
      } else {
        meta.setAttribute("content", previousDescription || DEFAULT_DESCRIPTION);
      }
    };
  }, []);

  return (
    <>
      <JsonLd data={jsonLd} id="structured-thinking-jsonld" />
      <PageContainer size="wide" className="mental-clarity-guide">
        <GuideCoverHero
          headline={STRUCTURED_THINKING_GUIDE.headline}
          lead={STRUCTURED_THINKING_GUIDE.description}
          cover={STRUCTURED_THINKING_COVER}
        />
        <GuideTableOfContents
          sections={STRUCTURED_THINKING_GUIDE.sections}
          basePath="/structured-thinking"
        />
        <nav className="guide-section-nav" aria-label="Pillar navigation">
          <div className="guide-section-nav__links">
            <Link
              to="/mental-noise"
              className="guide-section-nav__link guide-section-nav__link--prev"
            >
              &larr; Previous: Mental Noise
            </Link>
            <Link to="/emotional-awareness" className="guide-section-nav__link guide-section-nav__link--next">
              Next: Emotional Awareness &rarr;
            </Link>
          </div>
        </nav>
      </PageContainer>
    </>
  );
};

export default StructuredThinking;
